import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M114.967 64.3913C114.967 82.4783 105.21 98.3789 90.6733 106.925C90.6733 106.925 90.5737 107.025 90.4741 107.025C89.4785 107.621 88.4828 108.118 87.4872 108.615C86.9894 108.913 86.4916 109.112 85.9937 109.311C85.7946 109.41 85.5955 109.509 85.3963 109.609H85.2968C85.0977 109.708 84.799 109.807 84.5998 109.907C83.1064 110.602 81.5133 111.099 79.9203 111.596C79.7212 111.696 79.4225 111.795 79.2234 111.795C79.1238 111.795 79.0242 111.894 78.9247 111.894C78.8251 111.894 78.7255 111.894 78.7255 111.994C78.626 111.994 78.5264 111.994 78.4268 112.093C76.336 112.689 74.1456 113.087 71.8556 113.385C69.7647 113.683 67.6739 113.783 65.583 113.783C62.1979 113.783 58.9122 113.484 55.7262 112.789C55.527 112.789 55.3279 112.689 55.1288 112.689C54.4318 112.59 53.7349 112.391 53.0379 112.193C52.341 111.994 51.644 111.795 50.9471 111.596C48.1593 110.702 45.3715 109.609 42.7828 108.317C26.8525 100.068 16 83.4721 16 64.3913C16 37.0621 38.2028 15 65.4835 15C92.8637 15 114.967 37.0621 114.967 64.3913Z"
          fill="var(--blue-05)"
        />
        <rect x="45" y="74" width="40" height="9" rx="2" fill="#6C99F0" />
        <rect x="45" y="87" width="40" height="9" rx="2" fill="#6C99F0" />
        <rect x="45" y="100" width="40" height="9" rx="2" fill="#6C99F0" />
        <path
          d="M12.0167 53.9018C13.0101 54.0622 13.9486 53.3839 14.1129 52.3867C14.2772 51.3895 13.6051 50.451 12.6117 50.2905C11.6184 50.1301 10.6799 50.8084 10.5156 51.8056C10.3513 52.8028 11.0234 53.7413 12.0167 53.9018Z"
          fill="var(--blue-05)"
        />
        <path
          d="M113.497 33.8034C115.157 32.2786 115.273 29.6898 113.756 28.0212C112.239 26.3526 109.665 26.2361 108.005 27.7609C106.345 29.2857 106.229 31.8745 107.746 33.5431C109.263 35.2117 111.837 35.3282 113.497 33.8034Z"
          fill="var(--blue-05)"
        />
        <path
          d="M104.578 23.7067C105.277 23.0647 105.325 21.9747 104.687 21.2721C104.048 20.5696 102.964 20.5205 102.265 21.1625C101.566 21.8045 101.518 22.8945 102.156 23.5971C102.795 24.2997 103.879 24.3487 104.578 23.7067Z"
          fill="var(--blue-05)"
        />
        <path d="M14 82.1517H22.3033" stroke="#6C99F0" strokeWidth="2" strokeLinecap="round" />
        <path d="M18.1517 78V86.3034" stroke="#6C99F0" strokeWidth="2" strokeLinecap="round" />
        <path d="M105.364 86.0912H112.091" stroke="#6C99F0" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M108.728 82.7275V89.455" stroke="#6C99F0" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M11.2772 60.0754C11.9826 60.1894 12.649 59.7077 12.7657 58.9996C12.8823 58.2915 12.4051 57.6251 11.6997 57.5112C10.9943 57.3972 10.3279 57.8789 10.2113 58.587C10.0946 59.2951 10.5718 59.9615 11.2772 60.0754Z"
          fill="var(--blue-05)"
        />
        <path
          d="M36.2024 118.954C37.609 118.494 38.3787 116.975 37.9215 115.561C37.4643 114.146 35.9534 113.373 34.5468 113.832C33.1403 114.292 32.3706 115.811 32.8278 117.225C33.285 118.639 34.7959 119.413 36.2024 118.954Z"
          fill="var(--blue-05)"
        />
        <path
          d="M42.8577 121.048C43.8142 120.736 44.3375 119.703 44.0266 118.741C43.7157 117.78 42.6883 117.253 41.7319 117.566C40.7754 117.878 40.252 118.911 40.5629 119.873C40.8738 120.835 41.9012 121.361 42.8577 121.048Z"
          fill="var(--blue-05)"
        />
        <rect x="19" y="25" width="40" height="30" rx="3" fill="#6C99F0" />
        <rect x="71" y="25" width="40" height="30" rx="3" fill="#6C99F0" />
        <path
          d="M38 55V62.5C38 63.0523 38.4477 63.5 39 63.5H90.5C91.0523 63.5 91.5 63.0523 91.5 62.5V55"
          stroke="#6C99F0"
        />
        <circle cx="65" cy="64" r="6" fill="#6C99F0" />
        <g style={{ mixBlendMode: "multiply" }}>
          <path
            d="M63.0836 62.7519L66.4677 60.0454C66.637 59.91 66.8647 60.1007 66.7835 60.31L65.8297 62.768C65.802 62.8394 65.8108 62.9211 65.8529 62.9839L66.9609 64.637C67.0248 64.7324 67.0088 64.8647 66.9243 64.9394L63.5208 67.9479C63.3566 68.0931 63.1193 67.9108 63.1944 67.6971L64.1699 64.9184C64.1945 64.8486 64.1848 64.7702 64.1442 64.7096L63.0391 63.0609C62.9729 62.9621 62.9927 62.8246 63.0836 62.7519Z"
            fill="#6C99F0"
          />
        </g>
      </svg>
    </>
  );
};
